<div class="each-page">
    <!-- Page Header -->
    <div class="page-header">
        <div class="page-header__content">
            <div class="page-left gap-2.5">
                <div class="page-icon">
                    <img
                        src="../assets/img/dashboard.svg"
                        class="h-8"
                        alt="Languages"
                    />
                </div>

                <div class="page-headings">
                    <h1>{{ pageTitle }}</h1>

                    <p *ngIf="pageSubtitle">
                        {{ pageSubtitle }}
                    </p>
                </div>
            </div>
        </div>

        <div class="page-header-right">
            <div class="course-search">
                <svg
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    <path
                        d="m21 21-4.35-4.35m1.35-5.65a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                    ></path>
                </svg>

                <input
                    type="search"
                   
                    (ngModelChange)="onSearchChange()"
                    placeholder="Search languages..."
                    aria-label="Search languages"
                />

                <span class="search-shortcut">
                    Ctrl + K
                </span>
            </div>

            <button
                type="button"
                class="add-course-button"
                (click)="addLanguage()"
            >
                <svg
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    <path d="M12 5v14M5 12h14"></path>
                </svg>

                <span>Add Language</span>
            </button>
        </div>
    </div>

    <!-- Page Content -->
    <div class="page-content">
        <section class="course-table-card">
            <div
                class="table-responsive"
                *ngIf="
                    filteredLanguages.length > 0;
                    else noLanguages
                "
            >
                <table class="course-table">
                    <thead>
                        <tr>
                            <th>Name</th>

                            <th class="action-column">
                                Action
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            *ngFor="
                                let language of paginatedLanguages;
                                trackBy: trackByLanguageId
                            "
                        >
                            <td data-label="Name">
                                <div class="course-title-group">
                                    <h3>
                                        {{ language.name }}
                                    </h3>
                                </div>
                            </td>

                            <td
                                class="action-column"
                                data-label="Action"
                            >
                                <div
                                    ngbDropdown
                                    class="d-inline-block action-dropdown"
                                    container="body"
                                >
                                    <button
                                        type="button"
                                        class="btn btn-outline-primary"
                                        [id]="
                                            'languageActions' +
                                            language.id
                                        "
                                        ngbDropdownToggle
                                        aria-label="Language actions"
                                    >
                                        <i
                                            class="fa fa-ellipsis-v"
                                            aria-hidden="true"
                                        ></i>
                                    </button>

                                    <div
                                        ngbDropdownMenu
                                        [attr.aria-labelledby]="
                                            'languageActions' +
                                            language.id
                                        "
                                        class="dp-items"
                                    >
                                        <button
                                            type="button"
                                            ngbDropdownItem
                                            (click)="
                                                editLanguage(
                                                    language
                                                )
                                            "
                                        >
                                            <img
                                                src="../assets/img/edit.svg"
                                                class="h-4 mr-2"
                                                alt=""
                                            />

                                            Edit
                                        </button>

                                        <button
                                            type="button"
                                            ngbDropdownItem
                                            class="text-danger"
                                            (click)="
                                                deleteLanguage(
                                                    language
                                                )
                                            "
                                        >
                                            <img
                                                src="../assets/img/delete.svg"
                                                class="h-4 mr-2"
                                                alt=""
                                            />

                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <ng-template #noLanguages>
                <div class="empty-state">
                    <div>
                        <img
                            src="../../../../assets/img/no-data.svg"
                            class="h-64"
                            alt="No languages"
                        />
                    </div>

                    <h3>No data found</h3>

                    <p>
                        Try changing the language search
                        text.
                    </p>

                    <button
                        type="button"
                        class="clear-filter-button"
                        (click)="clearFilters()"
                    >
                        Clear filters
                    </button>
                </div>
            </ng-template>

            <!-- Pagination -->
            <div
                class="table-footer"
                *ngIf="filteredLanguages.length > 0"
            >
                <div class="pagination-summary">
                    Showing
                    <strong>{{ startItem }}</strong>
                    –
                    <strong>{{ endItem }}</strong>
                    of
                    <strong>
                        {{ filteredLanguages.length }}
                    </strong>
                    languages
                </div>

                <div class="pagination-container">
                    <ngb-pagination
                        [(page)]="page"
                        [pageSize]="pageSize"
                        [collectionSize]="
                            filteredLanguages.length
                        "
                        [maxSize]="5"
                        [rotate]="true"
                        [ellipses]="true"
                        [boundaryLinks]="false"
                        [directionLinks]="true"
                        aria-label="Language pagination"
                    >
                    </ngb-pagination>
                </div>

                <div class="page-size-control">
                    <label for="languagePageSize">
                        Rows per page
                    </label>

                    <select
                        id="languagePageSize"
                        [value]="pageSize"
                        (change)="onPageSizeChange($event)"
                    >
                        <option value="5">5</option>
                        <option value="8">8</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                    </select>
                </div>
            </div>
        </section>
    </div>
</div>